import { createGlobalStyle } from 'styled-components';
import Theme from './theme';
import backdrop from '../assets/images/backdrop.jpg';

const fonts = require('../assets/fonts/fonts.css');

const GlobalStyle = createGlobalStyle`

	html {
		height: -webkit-fill-available;
		min-height: 100%;
		height: 100%;	
		font-family: 'ZillaSlab', serif;
		font-size: 20px;
		user-select: none;
		box-sizing: border-box;
	}

	body {
		margin:0;
		padding:0;
		height: 100%;
		background-image: url(${backdrop});
		background-size: cover;
		background-repeat: no-repeat;
		background-attachment: fixed;
	}

	h1 {
		font-size: 2.2rem;
		margin-top: 0;
	}

	h2 {
		font-weight: 200;
		margin-top: 0;
	}

	P {
		margin-top: 0;
	}

	 // Extra small screens
	@media (max-width: ${Theme.responsive.media.sm}){
		p {
			font-size: 1rem;
		}
	}

	// Small screens (tablets, big phones, small monitors).
	@media (min-width: ${Theme.responsive.media.sm}){
		p {
			font-size: 1.7rem;
		}
	}

	/* // Large screens
	@media (min-width: ${Theme.responsive.media.lg}){
		p {
			font-size: 2rem;
		}
	}

	// Extra large screens
	@media (min-width: ${Theme.responsive.media.xl}){   
		p {
			font-size: 2rem;
		}
	} */

	* {
		box-sizing: border-box;
	}

	#root {
		height: 100%;
	}

	.d-none {
		display: none!important;
	}

	/* custom scroll bar */

	/* width */
	::-webkit-scrollbar {
		width: 7.5px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: ${Theme.colors.neutral};
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background:  ${Theme.colors.neutralLightest}; 
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}


.host-decision{
    text-shadow: 0.10em 0 #262626;
    color: white;
    text-transform: uppercase;
}

.host-decision-nr{
    text-shadow: 0.10em 0 grey;
    color: red;
    text-transform: uppercase;
    padding-right: .5em;
}

.db-id{
    color: ${Theme.colors.primary};
    text-shadow: 0.10em 0 #262626;
}

.stemmen {
     background-color: grey;
     text-shadow: 0.10em 0 #262626;
}

.decision-row {
    height: 40%;
}

.decision-lost{
    opacity: 0.333!important;
}

.hidden {
	visibility: hidden;
}

`;

export default GlobalStyle;
